<template>
<div class="packageBG">
    <div  data-v-a589c2a8="" id="clabs-section" class="clabsSection zoom-in" v-if="!isMobile()"> 
        <div  class="clabsSection__pass clabsSection__left">
            <a  name="CosmicLabs" class="clabsLink" id="CosmicLabs"></a> <img  src="../../assets/VX/bluewalk.gif" >
            <h3  class="is-text-bold TitleSection">Soldier</h3>
            <ul >
            <li >1500 Genesis VX Soldier Models</li>
            <li >Early Access to CosmicLabs Sandbox Land</li>
            <li >NFT/SAND Rewards in Play-To-Earn Ecosystem</li>
            <li >Raffle Entry to Cosmic Labs VX Launch Party(IRL)</li>
            </ul>
        </div>
        <div  class="clabsSection__pass">
            <img class="tier2Size"  src="../../assets/VX/tier2.gif">
            <h3  class="is-text-bold TitleSection">Commander</h3>
            <ul  class="second-list">
            <li >1,000 Genesis VX Commander Models</li>
            <li >Exclusive Genesis NFT items playable in Sandbox</li>
            <li >Early Access to CosmicLabs Sandbox Land</li>
            <li >NFT/SAND Rewards in Play-To-Earn Ecosystem</li>
            <li >Raffle Entry to Cosmic Labs VX Launch Party(IRL)</li>
            </ul>
        </div>
        <div  class="clabsSection__pass">
            <img  src="../../assets/VX/genesisMount.gif" >
            <h3  class="is-text-bold TitleSection">General</h3>
            <ul  class="second-list">
            <li >500 Genesis VX General Models</li>
            <li >Exclusive Genesis NFT items playable in Sandbox</li>
            <li >Exclusive Genesis NFT mount playable in Sandbox</li>
            <li >Early Access to CosmicLabs Sandbox Land</li>
            <li >NFT/SAND Rewards in Play-To-Earn Ecosystem</li>
            <li >Raffle Entry to Cosmic Labs VX Launch Party(IRL)</li>
            </ul>
        </div>
    </div>

    <b-container v-if="isMobile()">
        <b-row>
            <b-col cols="12">
                <div  data-v-a589c2a8="" id="clabs-section" class="clabsSectionMobile zoom-in"> 
                    <div  class="clabsSectionMobile__pass clabsSectionMobile__left">
                        <a  name="CosmicLabs" class="clabsLink" id="CosmicLabs"></a> <img  src="../../assets/VX/bluewalk.gif" >
                        <h3  class="is-text-bold TitleSection">Soldier</h3>
                        <ul >
                        <li >1500 Genesis VX Soldier Models</li>
                        <li >Early Access to CosmicLabs Sandbox Land</li>
                        <li >NFT/SAND Rewards in Play-To-Earn Ecosystem</li>
                        <li >Raffle Entry to Cosmic Labs VX Launch Party(IRL)</li>
                        </ul>
                    </div>
                    <div  class="clabsSectionMobile__pass">
                        <img class="tier2Size"  src="../../assets/VX/tier2.gif">
                        <h3  class="is-text-bold TitleSection">Commander</h3>
                        <ul  class="second-list">
                        <li >1,000 Genesis VX Commander Models</li>
                        <li >Exclusive Genesis NFT items playable in Sandbox</li>
                        <li >Early Access to CosmicLabs Sandbox Land</li>
                        <li >NFT/SAND Rewards in Play-To-Earn Ecosystem</li>
                        <li >Raffle Entry to Cosmic Labs VX Launch Party(IRL)</li>
                        </ul>
                    </div>
                    <div  class="clabsSectionMobile__pass">
                        <img  src="../../assets/VX/genesisMount.gif" >
                        <h3  class="is-text-bold TitleSection">General</h3>
                        <ul  class="second-list">
                        <li >500 Genesis VX General Models</li>
                        <li >Exclusive Genesis NFT items playable in Sandbox</li>
                        <li >Exclusive Genesis NFT mount playable in Sandbox</li>
                        <li >Early Access to CosmicLabs Sandbox Land</li>
                        <li >NFT/SAND Rewards in Play-To-Earn Ecosystem</li>
                        <li >Raffle Entry to Cosmic Labs VX Launch Party(IRL)</li>
                        </ul>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>
export default {
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.packageBG
{
    background-color: #1d232a;
}
.clabsSection {
    padding: 40px 0 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #1d232a;
    color: white;
}
.clabsSectionMobile {
    padding: 40px 0 80px;
    display: block;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #1d232a;
    color: white;
    
}
.TitleSection
{
    color: #82f5eb;
}
.clabsSection__pass {
    border: 3px solid #82f5eb;
    position: relative;
    background-color: #14181d;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 30px;
    padding: 60px;
    width: 540px;
    height: 800px;
    margin: 0 20px;
}
.clabsSectionMobile__pass {
    border: 3px solid #82f5eb;
    position: relative;
    background-color: #14181d;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 30px;
    padding: 60px;
    width: 100%;
    margin-top: 5vh;
    height: 850px;
    
}
.clabsLink {
    position: absolute;
    top: 0;
    right: unset;
    bottom: unset;
    left: 0;
    z-index: 1;
}
.clabsSection__pass img {
    
    height: 295px;
    -o-object-fit: contain;
    object-fit: contain;
}
.clabsSectionMobile__pass img {
    
    height: 295px;
    -o-object-fit: contain;
    object-fit: contain;
}
.tier2Size
{
    transform: scale(1.2);
}

.clabsSection__pass h3 {
    text-transform: uppercase;
    font-size: 30px;
    margin: 20px 0;
    text-align: left;
}
.clabsSection__pass p {
    font-size: 15px;
    line-height: 18px;
}
.clabsSection__pass ul {
    padding-left: 25px;
    padding-right: 25px;
    flex: auto;
}
.clabsSection__pass ul li {
    margin: 15px 0;
    line-height: 20px;
    font-size: 15px;
    position: relative;
}




.clabsSectionMobile__pass h3 {
    text-transform: uppercase;
    font-size: 30px;
    margin: 20px 0;
    text-align: left;
}
.clabsSectionMobile__pass p {
    font-size: 15px;
    line-height: 18px;
}
.clabsSectionMobile__pass ul {
    padding-left: 25px;
    padding-right: 25px;
    flex: auto;
}
.clabsSectionMobile__pass ul li {
    margin: 15px 0;
    line-height: 20px;
    font-size: 15px;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/Vx/Package.vue